import { AppError, ErrorFactoryUtils } from "../errorHandling";
import { useIntl } from "../i18n";
import { HttpError, HttpErrorCode } from "./http-error";


export class HttpErrorFactory {
    public static fromHttpError(exception: any, source: string, includeBodyAsDetail?: boolean): AppError {
        if (exception instanceof AppError) {
            return exception;
        }

        const withBody = includeBodyAsDetail ?? false;
        let statusCode = 0;
        if (exception.response && exception.response.status) {
            statusCode = exception.response.status;
        }

        let url = "";
        let method = "";
        if (exception.config) {
            if (exception.config.url) {
                url = exception.config.url;
            }

            if (exception.config.method) {
                method = exception.config.method;
            }
        }

        let error: HttpError;


        if ((statusCode === 0) || (statusCode >= 502 && statusCode <= 504)) { //Cors o disponibilidad 
            error = new HttpError("Network", HttpErrorCode.NetworkError, useIntl().i18n.t("shared.errors.errorTypes.httpError.networkError", { source }), url, method, statusCode, exception.stack, exception);
        }
        else if (statusCode >= 200 && statusCode <= 299) { //Probablemente JSON 
            error = new HttpError("Json", HttpErrorCode.JsonDataError, useIntl().i18n.t("shared.errors.errorTypes.httpError.invalidDataError", { source }), url, method, statusCode, exception.stack);
            error.details = ErrorFactoryUtils.getExceptionMessage(exception);
        }
        else {
            error = new HttpError(source, HttpErrorCode.ResponseError, useIntl().i18n.t("shared.errors.errorTypes.httpError.responseError", { source }), url, method, statusCode, exception.stack);
        }

        if (exception.response && exception.response.data && withBody) {
            let newDetails: string;

            if (typeof exception.response.data == "string")
                newDetails = exception.response.data;
            else
                newDetails = JSON.stringify(exception.response.data);

            if (error.details == null)
                error.details = `BODY:\n${newDetails}`;
            else if (typeof error.details == "string")
                error.details += `\nBODY:\n${newDetails}`;
            else if (typeof error.details == "object")
                error.details["__body"] = newDetails;
            else if (Array.isArray(error.details)) {
                error.details.push(newDetails);
            }
        }

        return error;
    }
}